import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const redefinicaoSenha = async (recuperacaoSenhaRequestDTO: {}): Promise<
  { info: string } | { message: string }
> => {
  try {
    const result = await apiService.post(
      `central/autenticacao/recuperacao-senha`,
      recuperacaoSenhaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'Senha redefinida com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const resetSenha = async (resetSenhaRequestDTO: {}): Promise<
  { info: string } | { message: string }
> => {
  try {
    const result = await apiService.post(
      `central/autenticacao/reset-senha`,
      resetSenhaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'E-mail enviado com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}
